<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-16 15:48:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/product/detail/components/TaxActionSheet/index.vue
-->
<template>
  <!-- 税费说明 -->
  <div class="con">
    <van-action-sheet v-model="show" title="税费说明" @close="close">
      <div class="content border_top1px">
        <div class="font14 font_weight500 colo087 text_left line_height_17">
          根据国家政策规定，购买跨境商品需缴纳“跨境综合税”
        </div>
        <div
          v-if="mallretailspu.includeTax !== 1"
          class="font12 font_weight400 colo087 text_left line_height_17 det_1"
        >
          · 税费预计：{{ mallretailspu.taxRat | currency(false) }}
        </div>
        <div
          v-if="mallretailspu.includeTax !== 1"
          class="font12 font_weight400 colo087 text_left line_height_17 det_2"
        >
          · 实际税费以提交订单时的价格明细为准
        </div>
        <div
          v-if="mallretailspu.includeTax === 1"
          class="font12 font_weight400 colof00 text_left line_height_17 det_1"
        >
          · 商品售价已包含税费，无需另付税费
        </div>
        <div
          class="font14 font_weight500 colof line_height_40 btn text_center"
          @click="close"
        >
          确认
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: true
    };
  },
  computed: {
    mallretailspu() {
      return this.$store.getters.mallretailspu;
    }
  },
  methods: {
    close() {
      this.show = true;
      this.$emit("closeSheet");
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  .content {
    margin: 2px 12px 0;
    padding: 16px 8px;
    .btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 20px;
      margin-top: 135px;
    }
    .det_1 {
      padding-top: 24px;
    }
    .det_2 {
      padding-top: 8px;
    }
  }
}
</style>
